<template>
    <info-screen
            class="startRegistration"
            :title="$ml.get('infoSelectLoginErrorTitle')"
            :text="$ml.get('infoSelectLoginErrorText')"
            :titleH1="false"
            :headerImg="16"
    >
        <template slot="bottom">
            <div class="left">
                <custom-button
                        :button-text="$ml.get('back')"
                        back
                        :action="back"
                ></custom-button>
            </div>
            <div class="right">
                <custom-button
                        ref="nextBtn"
                        :button-text="$ml.get('registration')"
                        success
                        :action="nextScreen"
                ></custom-button>
            </div>
        </template>
    </info-screen>
</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    import CustomButton from "../../components/ui/custom-button.vue";
    export default {
        name: "infoSelectLoginErrorPage",
        components: {
            CustomButton,
            InfoScreen},
        methods: {
            nextScreen: function () {
                this.$router.push({ name: 'LoginEnterLogin'});
            },

            back: function () {
                this.$router.back();
            },

        }
    }
</script>

<style scoped>

</style>